import React from 'react';
import { useSelector } from 'react-redux';
import CompanyScansTableComponent from './companyScansTable.component';

const CompanyScansTableContainer = () => {
  const companyTable = useSelector((state) => state.dashboard.companyTable.data);
  const isLoading = useSelector((state) => state.dashboard.companyTable.isLoading);
  const error = useSelector((state) => state.dashboard.companyTable.error);

  return (
    <CompanyScansTableComponent
      data={companyTable}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default CompanyScansTableContainer;
